import React, { useEffect, useState } from 'react';
import {
  Container,
  ImageContainer,
  ImageContainerImg,
  TextBlock
} from './styles';
import { ProductInfoParagraph, ProductInfoTitle } from '../styles';
interface IParams {
  contentText: JSX.Element | JSX.Element[] | string;
  title: string;
  productImage: string;
  imagePosition?: 'right' | 'left';
  contentImg?: JSX.Element | JSX.Element[] | string;
}

const ProductInformationSection = ({
  contentText,
  contentImg,
  title,
  imagePosition,
  productImage
}: IParams) => {
  const [blockImage, setBlockImage] = useState('');
  const mediaBaseUrl = '/media/catalog/product/';

  useEffect(() => {
    setBlockImage(contentImg?.toString() ?? '');
  }, [contentImg]);

  return (
    <Container imagePosition={imagePosition ?? 'right'}>
      <TextBlock>
        <ProductInfoTitle>{title}</ProductInfoTitle>
        <ProductInfoParagraph>{contentText}</ProductInfoParagraph>
      </TextBlock>

      <ImageContainer>
        <ImageContainerImg>
          <img
            src={`${process.env.REACT_APP_MEDIA_BASE_URL}${
              blockImage.length > 0 ? blockImage : mediaBaseUrl + productImage
            }`}
          />
        </ImageContainerImg>
      </ImageContainer>
    </Container>
  );
};

export default ProductInformationSection;
